var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('v-sheet',{staticClass:"login-container",attrs:{"rounded":""}},[_c('v-container',[_c('br'),_c('h2',{staticClass:"login-heading"},[_vm._v("Awaiting Sign In")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }